import React, { useState, useCallback, useEffect } from "react";
import { debounce } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { searchCatalogue } from "../../../../state/actions/catalogue";
import { setSearchLoader } from "../../../../state/actions/loader";
import { CircularProgress } from "@mui/material";

const MarketplaceSearch = () => {
    const [searchText, setSearchText] = useState("");
    const dispatch = useDispatch();
    const searchLoader = useSelector((state) => state.loader.searchLoader);

    const debouncedSearch = useCallback(
        debounce((value) => {
            if (value === "") {
                dispatch(setSearchLoader(false));
                dispatch(searchCatalogue(""));
            } else {
                dispatch(setSearchLoader(true));
                dispatch(searchCatalogue(value));
            }
        }, 300),
        [dispatch]
    );

    useEffect(() => {
        return () => {
            debouncedSearch.cancel();
            dispatch(searchCatalogue(""));
        };
    }, [debouncedSearch, dispatch]);

    const handleSearch = (value) => {
        setSearchText(value);
        debouncedSearch(value);
    };

    const clearSearch = () => {
        setSearchText("");
        dispatch(setSearchLoader(false));
        debouncedSearch("");
    };

    return (
        <div className="flex items-center justify-end space-x-2 w-full max-w-sm">
            <div className="relative w-full">
                <input
                    type="search"
                    placeholder="Search"
                    value={searchText}
                    onChange={(e) => handleSearch(e.target.value)}
                    className="w-full border border-[#D5D5FF] bg-[#F4F4FF] !text-primary-blue h-[35px] bg-transparent rounded-[10px] px-3 pr-8 py-1 focus:outline-none focus:ring-1 focus:ring-blue-100 placeholder:!text-[#666666] placeholder:text-[13px]"
                />

                {/* Right-side icon container */}
                <div className="absolute top-1.5 right-2 flex items-center justify-center h-5 w-5">
                    {searchLoader ? (
                        <CircularProgress size={14} className="text-[#007bff] opacity-60" />
                    ) : searchText ? (
                        <button
                            onClick={clearSearch}
                            className="text-gray-500 hover:text-gray-700 focus:outline-none"
                            aria-label="Clear search"
                        >
                            <i className="icon-cross text-sm" />
                        </button>
                    ) : (
                        <svg xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="currentColor"
                            className="size-5 absolute top-0 right-2 text-primary-blue opacity-45">
                            <path strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607Z" />
                        </svg>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MarketplaceSearch;
